/**
 * @file: 层板 update 方法
 * @author: xiaolong.huang@dmall.com
 */

import * as UIToolkit from '../../UIToolkit/index';
import Update from '../../update/index';

export default function update(cube: CubeNode, params: FreeObjMap = {}): void {
    UIToolkit.updateFreeLayerInShelfSize(cube.id);
    Update.updateDepByCubeId(cube.id);
    if (!params.notLayout) {
        UIToolkit.updateGoodsLayout(cube);
    }
    UIToolkit.layerCubeSortByPosition(cube.id);
}
